import type { DialogConfig } from '#types/config/components/dialog'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    heading: 'title-2',
    seeResultsCta: 'w-full',
    resetCta: 'px-2 text-sm underlined',
  },
  dialogOptions: { type: 'panel' },
  enableFiltersCollape: true
} satisfies RecursivePartial<DialogConfig['filters']>
